const translate = (t, key, fallback, params = {}) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key, params)

  return translated === key ? fallback : translated
}

const getAcceptItem = (t) => ({
  label: translate(t, 'deliveryRequest.actions.acceptRequest', 'Terima Permintaan'),
  key: 'ACCEPT',
})

const getRejectItem = (t) => ({
  label: translate(t, 'deliveryRequest.actions.rejectRequest', 'Tolak Permintaan'),
  key: 'REJECT',
})

export const actionDropdownItems = (t) => {
  const acceptItem = getAcceptItem(t)
  const rejectItem = getRejectItem(t)

  return [
    {
      ...acceptItem,
      color: '#137C55',
    },
    {
      ...rejectItem,
      color: '#F41D00',
    },
  ]
}

export const actionTransitionItems = (t) => {
  const acceptItem = getAcceptItem(t)
  const rejectItem = getRejectItem(t)

  return [
    {
      ...rejectItem,
      component: null,
      variant: 'secondary-red',
      icon: 'icon-outline_close',
      idModal: 'mc-modal-reject',
      message: {
        success: translate(t, 'deliveryRequest.toast.deliveryRequestRejected', 'Permintaan delivery berhasil ditolak'),
        failed: translate(t, 'deliveryRequest.toast.requestActionFailed', 'Terjadi kesalahan pada permintaan'),
      },
    },
    {
      ...acceptItem,
      component: null,
      variant: 'success',
      icon: 'icon-fill_checkmark',
      idModal: 'mc-modal-accept',
      message: {
        success: translate(t, 'deliveryRequest.toast.deliveryRequestAccepted', 'Permintaan delivery berhasil diterima'),
        failed: translate(t, 'deliveryRequest.toast.requestActionFailed', 'Terjadi kesalahan pada permintaan'),
      },
    },
  ]
}

export const actionTransitionItemsFleetTask = (t) => {
  const acceptItem = getAcceptItem(t)
  const rejectItem = getRejectItem(t)

  return [
    {
      ...rejectItem,
      component: null,
      variant: 'secondary-red',
      icon: 'icon-outline_close',
      idModal: 'mc-modal-reject',
      message: {
        success: translate(t, 'deliveryRequest.toast.fleetTaskRequestRejected', 'Permintaan fleet task berhasil ditolak'),
        failed: translate(t, 'deliveryRequest.toast.requestActionFailed', 'Terjadi kesalahan pada permintaan'),
      },
      color: '#F41D00',
    },
    {
      ...acceptItem,
      component: null,
      variant: 'success',
      icon: 'icon-fill_checkmark',
      idModal: 'mc-modal-accept',
      message: {
        success: translate(t, 'deliveryRequest.toast.fleetTaskRequestAccepted', 'Permintaan fleet task berhasil diterima'),
        failed: translate(t, 'deliveryRequest.toast.requestActionFailed', 'Terjadi kesalahan pada permintaan'),
      },
      color: '#137C55',
    },
  ]
}
